/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_NeverInputs */

const en_settings_never = /** @type {(inputs: Settings_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`never`)
};

const he_settings_never = /** @type {(inputs: Settings_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מעולם לא`)
};

/**
* | output |
* | --- |
* | "never" |
*
* @param {Settings_NeverInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_never = /** @type {((inputs?: Settings_NeverInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_NeverInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_never(inputs)
	return he_settings_never(inputs)
});